import styled from 'styled-components';
import Link from 'next/link';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';
import { FlexCenterAligned, FlexibleDiv } from '../../../../styled/common';

export const CurrentItemAddress = styled(Typography)`
  display: block;
  margin-bottom: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 20px;
  }
`;

export const LocationList = styled(FlexibleDiv)`
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-top: 20px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-top: 10px;
  }
`;

export const LocationLink = styled(Link).attrs({
  prefetch: false,
  locale: false
})`
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme }) => theme.colors.systemColors.blue};
`;

export const StyledMap = styled.div`
  width: 100%;
  height: 75px;
  border-radius: 7px;
  overflow: hidden;
  position: relative;
  background-image: url('/static/images/map_stub.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 45px;
    height: 45px;
    flex-shrink: 0;

    svg {
      position: absolute;
      top: 14px;
      left: 15px;
    }
  }
`;

export const MapOverlay = styled(FlexCenterAligned)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const ShowMapButton = styled.button`
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.systemColors.blue};
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: 10px 15px;
  min-width: 175px;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  height: 40px;
  cursor: pointer;
`;

export const ShowMapButtonText = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.blue};
`;

export const MapWrapper = styled.div`
  @media (min-width: ${Breakpoints.tablet}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    gap: 15px;
    background-color: ${({ theme }) => theme.colors.background.tertiary};
    border-radius: 14px;

    ${CurrentItemAddress} {
      margin-bottom: 0;
    }
  }
`;

export const MapInfo = styled.div`
  @media (min-width: ${Breakpoints.tablet}px) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }
`;

export const ShowOnMap = styled(Typography)`
  display: none;

  @media (min-width: ${Breakpoints.tablet}px) {
    display: inline-block;
    padding-bottom: 1px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.text.primary};
    cursor: pointer;
    white-space: nowrap;

    @media (hover: hover) {
      &:hover {
        transition: all 0.2s ease-in-out;
        color: ${({ theme }) => theme.colors.systemColors.blue};
        border-color: ${({ theme }) => theme.colors.systemColors.blue};
      }
    }
  }
`;
